export const TechnicalStatuses = {
    TechnicalAlerts: "technicalAlerts",
    GatewayStatus: "gatewayStatus",
    CowsNotSeen: "cowsNotSeen",
    CowsWithHighPm: "cowsWithHighPM"
}


// WEBPACK FOOTER //
// ./src/constants/technical_statuses.js